import React from "react";
import { formatDateFull } from "../../utils/helper";

export const RequestStatusNotification = ({ item }) => {
  const [status, title, start_date, due_date] = item.description.split("|");
  return (
    <div sx={{ fontSize: 12, marginTop: "5px" }}>
      <div className={"row"} spacing={1}>
        <div className={"col-sm-12"}>
          <b>Request has been {status}</b>
        </div>

        <div className={"col-sm-4"}>Title</div>
        <div className={"col-sm-1"}>:</div>
        <div className={"col-sm-7"}>{title}</div>
      </div>
    </div>
  );
};
